// React
import React from 'react';
import Dropzone from 'react-dropzone';
import { Link } from 'react-router-dom';
import {
  Col,
  Row,
  Form,
  Card,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

// Utils
import { getExtension } from '../../../../../../utils/fileFormatting';

export const ModalUploadFiles = ({
  toggle,
  isOpen,
  removeFile,
  handleSubmit,
  selectedFiles,
  handleAcceptedFiles,
}) => {
  return (
    <Modal
      centered
      isOpen={isOpen}
      className="modal-md"
      toggle={() => {
        toggle();
      }}
    >
      <ModalHeader>Anexar arquivos</ModalHeader>
      <Col className="modal-content border-0">
        <ModalBody className="modal-body mb-3">
          <Row className="g-3">
            <Col className="mb-2">
              <Dropzone
                multiple={true}
                maxFiles={3}
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone dz-clickable" {...getRootProps()}>
                    <div className="dz-message needsclick">
                      <div className="mb-3">
                        <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                      </div>
                      <h4>
                        Arraste e solte seus arquivos aqui ou{' '}
                        <span className="fw-bold text-decoration-underline">
                          selecione
                        </span>
                      </h4>
                    </div>
                    <input {...getInputProps()} />
                  </div>
                )}
              </Dropzone>
              <div className="list-unstyled mb-0" id="file-previews">
                {selectedFiles.map((f, i) => {
                  return (
                    <Card
                      className="mt-3 mb-3 p-3 border rounded"
                      key={i + '-file'}
                    >
                      <Row className="align-items-center">
                        <Col className="col-auto">
                          {['png', 'jpg', 'jpeg', 'svg'].indexOf(
                            getExtension(f.type)
                          ) > -1 && (
                            <img
                              data-dz-thumbnail=""
                              height={50}
                              width={80}
                              alt={f.name}
                              src={f.preview}
                            />
                          )}
                        </Col>
                        <Col>
                          <Link to="#" className="text-muted font-weight-bold">
                            {f.name}
                          </Link>
                          <p className="mb-0">
                            <strong>{f.formattedSize}</strong>
                          </p>
                        </Col>
                        <Col className="col-auto">
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => {
                              removeFile(i);
                            }}
                          >
                            Excluir
                          </button>
                        </Col>
                      </Row>
                    </Card>
                  );
                })}
              </div>
            </Col>
          </Row>
        </ModalBody>
        <Row className="modal-footer">
          <Col className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-link"
              onClick={() => {
                toggle();
              }}
            >
              Cancelar
            </button>
            <Button
              color="primary"
              disabled={selectedFiles.length === 0}
              onClick={() => {
                handleSubmit();
              }}
            >
              Enviar
            </Button>
          </Col>
        </Row>
      </Col>
    </Modal>
  );
};
